import React from "react";
import {
  Col,
  Dialog,
  FabButton,
  Flex,
  Gap,
  InputField,
  Row,
  SelectField,
  Typography,
} from "../../ppui";
import { TbPencil } from "react-icons/tb";
import { OrganizationBx, OrganizationEmDetails } from "../style";

const StatutoryGratuityActDetails = () => {
  // Modal
  const [setOpenPtaxModal, setOpenStatutoryPTAXModal] = React.useState(false);

  const handleOpenStatutoryPtaxModal = () => setOpenStatutoryPTAXModal(true);
  const handleCloseStatutoryPtaxModal = () => setOpenStatutoryPTAXModal(false);
  // Modal
  return (
    <>
      <Flex justifyContent="space-between" gap={"10"}>
        <Typography mb={"0"} variant="h5">
          Gratuity ACT Details
        </Typography>

        <FabButton
          size="sm"
          icon={<TbPencil />}
          onClick={handleOpenStatutoryPtaxModal}
          variant="filled"
          shape="box"
        />
      </Flex>
      <Gap height={30} />

      <OrganizationEmDetails>
        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            Gratuity Act No
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            ABF7674J
          </Typography>
        </OrganizationBx>

        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            Gratuity Type
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            Gratuity Run By Under Labour ACT.
          </Typography>
        </OrganizationBx>

        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            Deduction Circle
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            Monthly
          </Typography>
        </OrganizationBx>

        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            Gratuity ACT Coverage Date
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            02-11-2024
          </Typography>
        </OrganizationBx>
      </OrganizationEmDetails>

      {/* Statutory-EPF-Modal */}
      <Dialog
        title="Gratuity ACT"
        closeButton={true}
        fullWidth
        maxWidth="sm"
        buttonName={"Update"}
        open={setOpenPtaxModal}
        onClose={handleCloseStatutoryPtaxModal}
        onSubmit={() => alert("Submitted")}
        separator
      >
        <Row rowGap>
          <Col sm={6}>
            <InputField
              fullWidth
              label="Gratuity Act No"
              placeholder="Type Here..."
              type="text"
              required
            />
          </Col>

          <Col sm={6}>
            <SelectField
              fullWidth
              required
              label="Gratuity Type"
              options={[
                { id: "option1", name: "Gratuity Run By Under Labour ACT." },
                {
                  id: "option2",
                  name: "Gratuity Run By Any Insurance Company",
                },
              ]}
              placeholder="Select Here..."
            />
          </Col>

          <Col sm={6}>
            <InputField
              fullWidth
              label="Gratuity ACT Coverage Date"
              placeholder="Select Here..."
              type="date"
              valueSinc={true}
              required
            />
          </Col>
        </Row>
      </Dialog>
      {/* Statutory-EPF-Modal */}
    </>
  );
};

export default StatutoryGratuityActDetails;
